import { Component, OnInit } from '@angular/core';
import { forwardRef } from '@angular/core';
import { Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NG_VALIDATORS } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';
import { Validator } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { GlobalDataService } from '../../../../../shared-services/global-data.service';
import { switchMap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { merge } from 'rxjs';
import { PartnerAddressDto } from '../../../../../dtos/partnerAddressDto';
import { UserDto } from '../../../../../dtos/userDto';
import { UserDataService } from '../../../data-storage/user-data.service';

@Component({
    selector: 'app-user-billing-info',
    templateUrl: './user-billing-info.component.html',
    styleUrls: ['./user-billing-info.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserBillingInfoComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => UserBillingInfoComponent),
            multi: true
        }
    ]
})
export class UserBillingInfoComponent implements OnInit, ControlValueAccessor, Validator {

    @Input()
    readonlyOnValid: boolean;

    @Input()
    columns: number = 2;

    public billingForm: FormGroup;
    readonlyState: any;
    countries$: Observable<any>;
    private currentUser: UserDto;

    constructor(private translateService: TranslateService, private globalDataService: GlobalDataService, private userDataService:UserDataService) {
    }

    ngOnInit(): void {
        this.currentUser = this.userDataService.getUser();
        this.billingForm = new FormGroup({
            street: new FormControl('', {
                validators: Validators.required,
            }),
            country: new FormControl('', {
                validators: Validators.required,
            }),
            postcode: new FormControl('', {
                validators: [Validators.required],
            }),
            region: new FormControl('', {
                validators: [Validators.required],
            })
        });

        this.readonlyState = {
            street: this.readonlyOnValid && this.billingForm.controls.street.valid,
            country: this.readonlyOnValid && this.billingForm.controls.country.valid,
            postcode: this.readonlyOnValid && this.billingForm.controls.postcode.valid,
            region: this.readonlyOnValid && this.billingForm.controls.region.valid
        }

        this.countries$ = merge(this.translateService.onLangChange, new BehaviorSubject(this.translateService.defaultLang))
            .pipe(
                switchMap((lang) => this.globalDataService.getCountryJson())
            )

        let primaryAddress:PartnerAddressDto  = this.currentUser.addresses.find((el)=>el.primary);
        this.billingForm.controls.street.patchValue(primaryAddress.street);
        this.billingForm.controls.country.patchValue(primaryAddress.country);
        this.billingForm.controls.postcode.patchValue(primaryAddress.postalCode);
        this.billingForm.controls.region.patchValue(primaryAddress.area);
    }

    public onTouched: () => void = () => {
    };

    writeValue(val: any): void {
        val && this.billingForm.setValue(val, {emitEvent: false});
    }

    registerOnChange(fn: any): void {
        this.billingForm.valueChanges
            .subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        isDisabled ? this.billingForm.disable() : this.billingForm.enable();
    }

    validate(c: AbstractControl): ValidationErrors | null {
        return this.billingForm.valid ? null : {invalidForm: {valid: false, message: "basicInfoForm fields are invalid"}};
    }


}
